
//防抖
export function debounce (fn, time) {
  time = time || 500
  // 定时器
  let timer = null
  return function (...args) {
    var _this = this
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      timer = null
      fn.apply(_this, args)
    }, time)
  }
}


